export default {
    url: '/:id/target',
    template: `
        <courses-courses-add-target
            course="vm.course"
            departments="vm.departments"
            roles="vm.roles"
            levels="vm.levels"
            can-manage-course="vm.canManageCourse"
        />`,
    resolve: {
        course (CourseResource, $stateParams) {
            return CourseResource.get({
                id: $stateParams.id,
                expand: 'courseFields,courseTargetsWithValue.employee.drlsWithValue,courseI18ns,sites,planningGroups.planningGroupTargets' }).$promise;
        }
    },
    controller ($scope, CLASSIFIER_ENUM, course, classifiers, CourseService) {
        $scope.$parent.vm.step = 2;
        $scope.$parent.vm.course = course;
        this.course = course;
        this.canManageCourse = CourseService.canManageCourse(course);
        this.departments = classifiers.filter((classifier) => classifier.type === CLASSIFIER_ENUM.KEYS.DEPARTMENT);
        this.roles = classifiers.filter((classifier) => classifier.type === CLASSIFIER_ENUM.KEYS.ROLE);
        this.levels = classifiers.filter((classifier) => classifier.type === CLASSIFIER_ENUM.KEYS.LEVEL);
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/courses/add/target/index.js